import { z } from "zod";

export const editProfileSchema = z.object({
  user_id: z.number(),
  phone: z.string()
    .min(10, "Номер телефона должен быть не менее 10 символов")
    .max(16, "Номер телефона не может быть длиннее 16 символов"),
  address: z.string()
    .optional(),
  whatsapp: z.string()
    .min(10, "Номер WhatsApp должен быть не менее 10 символов")
    .max(16, "Номер WhatsApp не может быть длиннее 16 символов")
    .optional(),
  telegram: z.string()
    .min(2, "Логин в Telegram должен быть не менее 2 символов")
    .optional(),
  first_name: z.string()
    .max(256, "Имя не может быть длиннее 256 символов")
    .optional(),
  last_name: z.string()
    .max(512, "Фамилия не может быть длиннее 512 символов")
    .optional(),
  employ_date: z.string().optional(),
  unemploy_date: z.string().optional(),
  birth_date: z.string().optional(),
  city: z.string()
    .min(3, "Название города должно быть не менее 3 символов")
    .optional(),
  date_updated: z.string().optional(),
  date_employed: z.string().optional(),
  date_unemployed: z.string().optional()
});

export type EditProfileSchemaType = z.infer<typeof editProfileSchema>;
